<template>
	<div>
		<div class="flex" style="margin-bottom: 10px;"><el-button type="primary" @click="addNews(false)">添加新闻</el-button></div>
		<el-table
			:data="newsList"
			style="width: 100%;margin-bottom: 20px;"
			row-key="id"
			border
			:stripe="true"
			:default-sort="{ prop: 'ctime', order: 'ascending' }"
			@sort-change="sortChange"
		>
			<el-table-column prop="id" label="新闻ID" width="80"></el-table-column>
			<el-table-column prop="title" label="新闻标题"></el-table-column>
			<el-table-column prop="ctime" label="创建时间" sortable></el-table-column>
			<el-table-column prop="utime" label="修改时间" sortable></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click="addNews(scope.row)">修改</el-button>
					<el-button type="danger" size="small">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="thispage"
				:page-sizes="pageSizes"
				:page-size="pagesize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</div>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
	name: '',
	data() {
		return {
			newsList: [],
			groupList: [],
			loading: false,
			thispage: 1,
			total: 0,
			pagesize: 10, //每页显示条数
			pageSizes: [10, 20, 30] ,//每页显示个数选择器
			sort_param:'',//排序字段
			sort_type:''//排序方式ascending = asc;descending = desc,'' = asc;
		};
	},
	mounted() {
		this.getNewsList();
	},
	methods: {
		...mapActions({
			exit: 'auth/logout'
		}),      
		getNewsList() {
			this.$axios({
				url: this.HOST + '/admin.news/newsList',
				method: 'post',
				data: {
					thispage: this.thispage,
					pagesize: this.pagesize,
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					sort_param:this.sort_param,
					sort_type:this.sort_type 
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.total = res.data.total;
						this.newsList = res.data.data;
						if (this.thispage == 1) {
							this.groupList = res.data.groupList;
						}
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			this.sort_param = prop;
			this.sort_type = order == 'descending'?'desc':'asc';
			this.getNewsList()
		},
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getNewsList();
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getNewsList();
		},
		addNews(scope = '') {
			if(scope){
				this.$router.push({path:'news/add',query:{'id':scope.id}});
			}else{
				this.$router.push({path:'news/add',query:{'id':''}});
			}
			
		},
	}
};
</script>
<style>
.el-tree-node.is-expanded > .el-tree-node__children {
	display: flex;
	flex-flow: row wrap;
}
.el-tree::-webkit-scrollbar {
	display: none; /* Chrome Safari */
}
</style>
